module.exports = "/virtual-football-league/img/amblems/left/logos/Bournmouth.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Bournmouth.png
// module id = 2058
// module chunks = 4